import React from "react";
import {BrandRequest} from "../model/BrandTypes";
import {BrandTheme} from "src/modules/brand/BrandConfig";
import {resolveLogoUrl} from "src/modules/brand/readBrandConfig";

interface Props {
    form: BrandRequest;
    theme: BrandTheme | null;
    logoUrl: string;
}

/**
 * The borrower's first screen, at a glance.
 *
 * Uses the theme returned by the API rather than recomputing contrast here, so the preview and
 * the real page cannot disagree. Before the first save there is no theme yet, so the raw color
 * is shown with a conservative dark text.
 */
export class BrandPreview extends React.Component<Props> {

    render() {
        const {form, theme, logoUrl} = this.props;
        const surface = theme ? theme.surface : form.primaryColor;
        const onSurface = theme ? theme.onSurface : "#222222";

        return (
            <div className="branding__card branding__previewCard">
                <h3>Live preview</h3>
                <p className="branding__help">
                    simpl. owns the top; the lender sits above the untouched home block.
                </p>
                <div className="brand-preview">
                    <div className="brand-preview__tile" style={{background: surface, color: onSurface}}>
                        <div className="brand-preview__hero">
                            <span className="brand-preview__paying">Paying is</span>
                            <span className="brand-preview__simpl">simpl.</span>
                        </div>
                        <div className="brand-preview__bottom">
                            <div className="brand-preview__label">YOUR LOAN IS WITH</div>
                            {logoUrl
                                ? <span className="brand-preview__chip"><img src={resolveLogoUrl(logoUrl)} alt=""/></span>
                                : <div className="brand-preview__lender">
                                    {form.displayName || "Lender name"}
                                  </div>}
                            <div className="brand-preview__legal">
                                {form.relationshipLine || ""}
                            </div>
                            <div className="brand-preview__platform">
                                Powered by Network Funding, LP.<br/>
                                NMLS #{form.nmls || "2297"} | Equal Housing Lender
                            </div>
                        </div>
                    </div>
                    <div className="brand-preview__form">
                        <div className="brand-preview__prompt">Enter your loan number to get started:</div>
                        <div className="brand-preview__input"/>
                        <div className="brand-preview__button">Start Payment</div>
                        <div className="brand-preview__link"
                             style={{color: theme ? theme.linkOnWhite : form.primaryColor}}>
                            call or email your loan officer
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
